<template>
    <v-data-table
        :items="tasks"
        :headers="headers"
        :loading="loading"
        no-data-text="Brak kolejnych zaplanowanych zadań"
        :items-per-page="3"
        :mobile-breakpoint="0"
        :hide-default-footer="true"
    >
        <template #item.taskNumber="{item}">
            {{ item.procNumber }}
        </template>

        <template #item.plate="{item}">
            {{ parseEmptyValue(item.procPlateNumber) }}
        </template>

        <template #item.closedFormat="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.closedFormat) }}
        </template>

        <template #item.quantity="{item}">
            {{ item.procTaskQuantity }}
        </template>

        <template #item.volume="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.volume) }}
        </template>

        <template #item.foldedSignaturesQuantity="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.foldedSignaturesQuantity) }}
        </template>

        <template #item.coverStatus="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.coverStatus) }}
        </template>

        <template #item.innerStatus="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.innerStatus) }}
        </template>

        <template #item.date="{item}">
            {{ formatDate(item.procTaskStartTime) }}
        </template>

        <template #item.procTaskStartTime="{item}">
            {{ formatDate(item.procTaskStartTime) }}
        </template>

        <template #item.procTaskDuration="{item}">
            {{ parseDuration(item.procTaskDurationSeconds) }}
        </template>

        <template #item.status="{item}">
            {{ item.procStatus | lowercase }}
        </template>

        <template #item.materialStatus="{item}">
            <div class="d-inline-flex">
                <v-tooltip :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <v-icon
                            v-if="isWarehouseHasReportedStatus(item)"
                            color="green"
                            v-on="on"
                        >
                            mdi-clipboard-check
                        </v-icon>
                        <v-icon v-else color="pink" v-on="on">
                            mdi-clipboard-alert
                        </v-icon>
                    </template>
                    <div>
                        <div>MAGAZYN: {{ parseEmptyValue(item.wareHouseStatus) }}</div>
                        <div>CTP: {{ parseBooleanValue(item.CTPStatus) }}</div>
                        <div>GUMA: {{ parseBooleanValue(item.rubberStatus) }}</div>
                    </div>
                </v-tooltip>
            </div>
        </template>

        <template #item.previews="{item}">
            <v-tooltip :open-delay="tooltipDelay" top>
                <template #activator="{on}">
                    <v-icon
                        :disabled="!hasPreviews(item)"
                        class="previews-icon"
                        v-on="on"
                        @click="openPreviewsViewer(item)"
                    >
                        mdi-magnify
                    </v-icon>
                </template>
                <span>{{ hasPreviews(item) ? 'Otwórz podglądy' : 'Brak podglądów' }}</span>
            </v-tooltip>
        </template>

        <template #item.productionProcessFB="{item}">
            {{ parseEmptyValue(item.productionProcessFB && item.productionProcessFB.name) }}
        </template>
    </v-data-table>
</template>

<script>
import { apiConfig } from '@/config'
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'PrintingTasksTable',
    mixins: [dateFormatter, parse, tooltipDelay],
    props: {
        tasks: {
            type: Array,
            default: null
        },
        loading: {
            type: Boolean
        }
    },
    data() {
        return {
            headers: [
                { text: 'Nr zlecenia', value: 'procNumber', align: 'left', sortable: false },
                { text: 'Montaż', value: 'procPlateNumber', align: 'center', sortable: false },
                { text: 'Sposób druku', value: 'printMethod', align: 'center', sortable: false },
                { text: 'Strona', value: 'procTaskPage', align: 'center', sortable: false },
                { text: 'Rodzaj surowca', value: 'paper', align: 'center', sortable: false },
                { text: 'Format surowca', value: 'format', align: 'center', sortable: false },
                { text: 'Nakład brutto', value: 'procTaskQuantity', align: 'center', sortable: false },
                { text: 'Zaplanowany start', value: 'procTaskStartTime', align: 'center', sortable: false },
                { text: 'Czas druku', value: 'procTaskDuration', align: 'center', sortable: false },
                { text: 'Kolorystyka str. A', value: 'coloursPageA', align: 'center', sortable: false },
                { text: 'Kolorystyka str. B', value: 'coloursPageB', align: 'center', sortable: false },
                { text: 'Lakier str. A', value: 'varnishSideA', align: 'center', sortable: false },
                { text: 'Lakier str. B', value: 'varnishSideB', align: 'center', sortable: false },
                { text: 'Liczarka (co ile arkuszy)', value: 'inserterBatch', align: 'center', sortable: false },
                { text: 'Status materiałów', value: 'materialStatus', align: 'center', sortable: false },
                { text: 'Podglądy', value: 'previews', align: 'center', sortable: false }
            ]
        }
    },
    methods: {
        hasPreviews(item) {
            return item.previews && item.previews.length > 0
        },
        openPreviewsViewer(item) {
            if (!this.hasPreviews(item)) return

            const mediaRoot = apiConfig.FACTORYBASE_API_URI
            const urls = item.previews.map(preview => `${mediaRoot}${preview}`)

            if (!urls.length) return

            this.$viewerApi({
                images: urls,
                options: {
                    toolbar: true,
                    navbar: true,
                    title: false,
                    keyboard: true
                }
            })
        },
        isWarehouseHasReportedStatus(item) {
            return item.wareHouseStatus !== 'NOT_REPORTED' &&
                   item.rubberStatus !== false &&
                   item.CTPStatus !== false
        }
    }
}
</script>
